import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import {
  ResourceSharingOffer,
  UserRapidoResourceSharingRequest,
} from 'app/entity/models/rapido-offer';
import { catchError, Observable, of, map } from 'rxjs';
import { SearchResult } from 'search/models/search-results';

@Injectable({
  providedIn: "root",
})
export class RapidoOffersService {
  private readonly offersUrl = 'api/search-result/rapido/resources/rs-offers';
  private readonly requestsUrl = 'api/search-result/rapido/users/rs-requests';

  constructor(private readonly http: HttpClient) {}

  public getOffers(recordId: string): Observable<ResourceSharingOffer[]> {
    return this.http
      .get<ResourceSharingOffer[]>(`${this.offersUrl}/${recordId}`)
      .pipe(
        catchError(() => {
          return of([]);
        })
      );
  }

  public placeRequest(payload: UserRapidoResourceSharingRequest) {
    return this.http.post<any>(this.requestsUrl, payload);
  }

  public getResource(resourceId: string): Observable<SearchResult> {
    const url = `api/search-result/search/instances/${resourceId}`;

    return this.http.get<SearchResult>(url, {
      params: {
        rapido: true
      }
    }).pipe(
      map(response => response)
    );
  }
}
